module.exports = __webpack_public_path__ + "img/supportPoster720.68ead259.jpg";